import { gql } from '@apollo/client';
export const PERSON_FOR_LINK_QUERY = gql`
    query PersonForLink($personId: UUID!) {
        person(id: $personId) { 
            ...PeopleForLink__Person
        }
    }
`